/* Elevate Floors — botão "ver mais" do grid de mídia.

   O JS aqui NÃO cria peça nenhuma. Todas já estão no HTML, as extras apenas
   com .is-hidden; o clique só tira a classe. É o que mantém a galeria inteira
   indexável: imagem injetada por script não entra no Google Imagens, e nesta
   página as fotos são o conteúdo que traz visita.

   A ordem das três operações do clique é a parte delicada e está comentada
   dentro de reveal(). */
(function () {
  'use strict';

  var BATCH_STEP = 45;   /* ms entre uma peça e a seguinte, igual ao CSS */
  var ANIM_MS = 500;     /* duração da transição, igual ao CSS */

  function reveal(wrap) {
    var grid = wrap.querySelector('.ef-mgrid');
    var more = wrap.querySelector('.ef-mgrid-more');
    var btn = wrap.querySelector('[data-mg-more]');
    if (!grid || !more || !btn) return;

    var hidden = grid.querySelectorAll('.ef-mgrid__item.is-hidden');
    if (!hidden.length) { more.classList.add('is-done'); return; }

    var step = parseInt(btn.getAttribute('data-mg-step'), 10) || 8;
    var batch = Array.prototype.slice.call(hidden, 0, step);
    var rest = hidden.length - batch.length;

    /* 1. ÂNCORA, medida antes de qualquer mutação.
       O container do botão serve melhor que o botão: quando o acervo acaba e o
       botão sai, o topo do container continua sendo o mesmo ponto da página. */
    var before = more.getBoundingClientRect().top;

    /* 2. REVELAR. .is-enter entra ANTES de tirar .is-hidden — na ordem inversa
       a peça aparece já no lugar final e só então começa a animar, o que se vê
       como um pisca. O --i é o índice dentro DESTE lote: usar o índice global
       faria o segundo clique esperar meio segundo antes da primeira peça. */
    batch.forEach(function (item, i) {
      item.style.setProperty('--i', i);
      item.classList.add('is-enter');
      item.classList.remove('is-hidden');
    });

    var countEl = wrap.querySelector('[data-mg-rest]');
    if (countEl) countEl.textContent = rest;

    var ended = rest === 0;

    /* 3. CORRIGIR O SCROLL, com o layout já refluído.
       O masonry por columns redistribui as peças entre as colunas a cada lote:
       a altura do grid muda e tudo abaixo dele desce. Sem esta compensação o
       botão foge de debaixo do dedo. getBoundingClientRect força o reflow. */
    var delta = more.getBoundingClientRect().top - before;
    if (Math.abs(delta) > 1) window.scrollBy(0, delta);

    /* Só depois de medir. Escondido, não removido: o container segue no DOM e
       continua servindo de âncora. E medi-lo já com display:none devolveria
       zero — por isso esta linha não pode subir. */
    if (ended) more.classList.add('is-done');

    /* 4. SÓ AGORA o fade. Em frame separado: no mesmo frame o navegador junta
       as duas mudanças de classe e não há transição nenhuma. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        batch.forEach(function (item) { item.classList.add('is-in'); });
      });
    });

    /* Limpeza: sem isto o transition-delay fica grudado e um hover futuro na
       peça responderia com atraso. */
    setTimeout(function () {
      batch.forEach(function (item) {
        item.classList.remove('is-enter', 'is-in');
        item.style.removeProperty('--i');
      });
    }, ANIM_MS + batch.length * BATCH_STEP + 120);

    /* Quem clicou pelo teclado ficaria com o foco no body quando o botão some.
       Mandar para a primeira peça nova mantém a navegação onde a pessoa estava. */
    if (ended && batch[0]) batch[0].focus({ preventScroll: true });
  }

  function bind(scope) {
    (scope || document).querySelectorAll('.ef-mgridwrap').forEach(function (wrap) {
      if (wrap._efMoreBound) return;
      wrap._efMoreBound = true;
      wrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mg-more]');
        if (!btn) return;
        reveal(wrap);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }

  /* O editor recarrega a seção sozinho e o listener antigo vai junto. */
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
